import React from 'react';
import './HeroSection.css';
import JobCards from '../job-cards/JobCards';

function HeroSection() {
  return (
    <section className="hero-section">
      <div className="hero-section-container" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg.png)` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          {/* <img className="nic-logo white-logo" src="/images/logo1.png" alt="Aditya Electro Projects logo" /> */}
          <h2 className="main-title">Aditya Electro Projects</h2>
          <h3 className="strapline">Empowering Communities Through Innovative <br/> MEP Solutions</h3>
          <p className="hero-lead">At Aditya Electro Projects, we are dedicated to providing community-focused MEP solutions that make a difference. Our objective is to provide complete solutions to construction industries using value engineering and modern technologies, delivered in a controlled, professional manner.</p>
        </div>
      </div>
      {/* <div className="areas-list-container">
        <div className="areas-image-content">
          <h2 className="areas-card-title">Aditya Electro Projects</h2>
          <p className="areas-card-lead">Aditya Electro Projects has a long history of milestones since its formation in 2008. We deliver high-quality building services engineering covering procurement, installation, testing and commissioning of multi-service installations including Electrical (HT/LT panels), Fire Fighting, Plumbing, Sanitary Works, and Fire Detection/Protection Systems.</p>

          <h3 className="areas-card-sub">Areas Covered</h3>
          <ul className="areas-list">
            <li>Hertfordshire</li>
            <li>Hatfield</li>
            <li>St. Albans</li>
            <li>Welwyn Garden City</li>
            <li>Welham Green</li>
            <li>North London</li>
          </ul>

          <p className="areas-card-foot">Our objective is to provide complete solutions to construction industries using value engineering and modern technologies, delivered in a controlled, professional manner.</p>
        </div>
      </div> */}
      <JobCards />
    </section>
  );
}

export default HeroSection;
